import React, { useState } from 'react';

import { List } from 'antd';

import styled from 'styled-components';

import { useContactSocials, useRemoveContactSocial } from '@hooks/API/Contact/UseContactSocials';

import { NwAddButton } from '@components/Gui/NwButton';
import NwDrawer from '@components/Gui/NwDrawer';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';
import ObjectLogHistories from '@components/ObjectLogHistories/ObjectLogHistories';
import SocialForm from '@components/Social/SocialForm';

import ContactSocialLink from './ContactSocialLink';
import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const ListItem = styled(List.Item)`
    justify-content: space-between;
    .ant-list-item-action {
        margin-left: 0;
    }
`;

const SocialsDrawer = ({ contactID, contactType, onClose }) => {
    const { data: socials, isFetching } = useContactSocials(contactID);
    //const [showModal, setShowModal] = useState(false);
    const [editSocial, setEditSocial] = useState(null);
    const [newSocial, setNewSocial] = useState(null);
    const [selectedSocial, setSelectedSocial] = useState();

    const { mutateAsync: deleteSocial } = useRemoveContactSocial();

    const handleEditSocial = (social) => async () => {
        setSelectedSocial(social);
        setEditSocial(true);
    };

    const handleRemoveSocial = (social) => async () => {
        try {
            await deleteSocial({ ID: social.ID, ContactID: contactID });
        } catch (error) {
            console.error('Remove Social Error => ', error);
        }
    };

    const actions = (social) => {
        return [
            <NwDropDownMenu
                loading={isFetching}
                actions={[
                    {
                        name: '',
                        key: 'edit',
                        pinned: true,
                        icon: byPrefixAndName.fasl['pen'],
                        action: handleEditSocial(social),
                    },
                    {
                        name: 'delete',
                        type: 'delete',
                        key: 'delete',
                        icon: byPrefixAndName.fasl['trash-alt'],
                        confirmationPlacement: 'left',
                        action: handleRemoveSocial(social),
                    },
                ]}
            />,
        ];
    };

    const handleCloseSocial = () => {
        setSelectedSocial();
        setEditSocial(false);
        setNewSocial(false);
        //setShowModal(false);
    };

    return (
        <NwDrawer onClose={onClose} title="Socials" width="40rem">
            <div className="drawer-toolbar-container">
                <NwAddButton primary onClick={() => setNewSocial(true)} label="Add a new social link" />
            </div>
            <br />
            <List
                itemLayout="horizontal"
                dataSource={socials}
                loading={isFetching}
                renderItem={(social) => (
                    <ListItem actions={actions(social)}>
                        <ContactSocialLink contactSocial={social} contactType={contactType} showUrl />
                    </ListItem>
                )}
            />
            {editSocial && (
                <NwDrawer title="Edit Social Link" onClose={handleCloseSocial}>
                    <SocialForm contactID={contactID} contactType={contactType} selectedSocial={selectedSocial} onClose={handleCloseSocial} />
                </NwDrawer>
            )}
            {newSocial && (
                <NwDrawer width="60rem" title="New Social Link" onClose={handleCloseSocial}>
                    <SocialForm contactID={contactID} contactType={contactType} onClose={handleCloseSocial} />
                </NwDrawer>
            )}
        </NwDrawer>
    );
};

export default SocialsDrawer;
